export default [
    {
      path: 'd-fin/gefin-financeiro',
      name: 'gefin-financeiro',
      component: () => import('./index'),
      children: [],
      meta: {
        visible: false,
        title: 'Financeiro',
        order: '2',
        breadcrumb: [
          { name: 'Home', link: 'home' },
          { name: 'D-FIN', link: 'd-fin' },
          { name: 'Financeiro' }
        ]
      }
    },
  ]